import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "15 3 21 3 21 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "9 21 3 21 3 15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "14", y1: "3", y2: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "10", y1: "21", y2: "14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Maximize2";
const Maximize2 = memo(themed(Icon));
export {
  Maximize2
};
//# sourceMappingURL=maximize-2.js.map
